import './App.css';
import TodoList from './components/toDoList';

const App = () => (
  <div className="App">
    <TodoList />
  </div>
);

export default App;
